export const FooterRestPath = 'globals/footer'
